var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.667 5.317a.65.65 0 0 1 0-1.3h6.666a.65.65 0 0 1 .65.65v6.666a.65.65 0 1 1-1.3 0V6.236l-5.557 5.557a.65.65 0 0 1-.919-.92l5.557-5.556H4.667Z",
    fill: "currentColor"
  })));
};

export { Svg16 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjY2NjY3IDUuMzE2NjdDNC4zMDc2OSA1LjMxNjY3IDQuMDE2NjcgNS4wMjU2NSA0LjAxNjY3IDQuNjY2NjdDNC4wMTY2NyA0LjMwNzY4IDQuMzA3NjkgNC4wMTY2NyA0LjY2NjY3IDQuMDE2NjdIMTEuMzMzM0MxMS42OTIzIDQuMDE2NjcgMTEuOTgzMyA0LjMwNzY4IDExLjk4MzMgNC42NjY2N1YxMS4zMzMzQzExLjk4MzMgMTEuNjkyMyAxMS42OTIzIDExLjk4MzMgMTEuMzMzMyAxMS45ODMzQzEwLjk3NDQgMTEuOTgzMyAxMC42ODMzIDExLjY5MjMgMTAuNjgzMyAxMS4zMzMzVjYuMjM1OTFMNS4xMjYyOSAxMS43OTNDNC44NzI0NSAxMi4wNDY4IDQuNDYwODkgMTIuMDQ2OCA0LjIwNzA1IDExLjc5M0MzLjk1MzIxIDExLjUzOTEgMy45NTMyMSAxMS4xMjc2IDQuMjA3MDUgMTAuODczN0w5Ljc2NDEgNS4zMTY2N0g0LjY2NjY3WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";